import * as React from 'react'
import { useEffect } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { BtnV2, l, Modal, SectionMessage } from '@manychat/manyui'

import { useAppDispatch, useAppSelector } from 'reduxTyped'
import { closeInstagramChangeConnectionModal } from 'common/core/actions/uiActions'
import { PermissionType } from 'common/core/hooks/permissions/types'
import { getPageId } from 'common/core/selectors/appSelectors'
import { getIsInstagramChangeConnectionModal } from 'common/core/selectors/uiSelectors'
import { getReloadPermissionsUrlPath } from 'common/core/utils/getReloadPermissionsUrlPath'
import { typedRouting } from 'utils/router'
import { analyticsService } from 'utils/services/analytics'
import { addURLParam } from 'utils/url'

import { CHANGE_CONNECTION_ERROR_PARAM } from './constants'
import { useInstagramChangeConnectionError } from './useInstagramChangeConnectionError'

import cm from './InstagramChangeConnectionModal.module.css'

export const InstagramChangeConnectionModal = () => {
  useInstagramChangeConnectionError()

  const dispatch = useAppDispatch()
  const pageId = useAppSelector(getPageId)
  const { isOpen, returnUrl, disableClose } = useAppSelector(getIsInstagramChangeConnectionModal)
  const currentUrl = window.location.href
  const refreshIgPermissionsUrlPath = getReloadPermissionsUrlPath({
    pageId,
    returnUrl: returnUrl ?? currentUrl,
    errorReturnUrl: addURLParam(currentUrl, CHANGE_CONNECTION_ERROR_PARAM, '1'),
    type: PermissionType.INSTAGRAM_CONFIG_PERMISSIONS,
  })

  useEffect(() => {
    if (isOpen) {
      analyticsService.sendEvent('INSTAGRAM_CHANGE_CONNECTION_MODAL.OPENED')
    }
  }, [isOpen])

  const handleClose = () => {
    dispatch(closeInstagramChangeConnectionModal())
    analyticsService.sendEvent('INSTAGRAM_CHANGE_CONNECTION_MODAL.CLOSED')
  }

  const handleClick = () => {
    analyticsService.sendEvent('INSTAGRAM_CHANGE_CONNECTION_MODAL.UPDATE_PERMISSIONS')
  }

  return (
    <Modal
      contentPadding="none"
      width={640}
      open={isOpen}
      disableCloseButton={disableClose}
      onRequestClose={disableClose ? undefined : handleClose}
    >
      <div className={cm.wrapper}>
        <h1 className={cm.heading}>
          {l.translate('Update your Instagram permissions to say hi to new followers')}
        </h1>

        <p className="m-t-lg">
          {l.translate(
            'To use this automation, you’ll need to update your Instagram permissions to sync with the latest connection.',
          )}
        </p>

        <SectionMessage
          variant="info"
          description={l.translate(
            'Previous automations and contacts stay right where they are, running just like before',
          )}
          className="m-t-lg"
        />

        <div className="m-t-lg">
          <BtnV2 variant="primary" as="a" href={refreshIgPermissionsUrlPath} onClick={handleClick}>
            {l.translate('Update permissions')}
          </BtnV2>

          {disableClose && (
            <BtnV2
              variant="ghost-primary"
              className="m-l"
              as={RouterLink}
              to={typedRouting.linkBuilder.dashboard()}
              onClick={handleClose}
            >
              {l.translate('Go to Home page')}
            </BtnV2>
          )}
        </div>
      </div>
    </Modal>
  )
}
